const getSharePercentage = (
  current?: number,
  total?: number,
  decimal: number = 0,
): number => {
  if (!current && !total) return 0;
  if (!total) return 0;

  const share = ((current || 0) / total) * 100;

  return Number(share.toFixed(decimal));
};

const formatDecimal = (value: number, fixed?: number): number => {
  if (Number.isInteger(value)) {
    return value;
  }
  return Number(value.toFixed(fixed || 1));
};

const getPositiveNumberIfValueIsNumber = <T>(value: T) => {
  const isNan = Number.isNaN(Number(value));

  if (isNan) return value;

  return Math.max(Number(value), 0);
};

const numberUtils = {
  getSharePercentage,
  formatDecimal,
  getPositiveNumberIfValueIsNumber,
};

export default numberUtils;
